var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import '@gouvfr/dsfr/dist/component/radio/radio.min.css';
import { BoutonRadioDefaultProps } from "./BoutonRadio.types";
var BoutonRadio = React.forwardRef(function (_a, ref) {
    var label = _a.label, name = _a.name, value = _a.value, disabled = _a.disabled, texteAide = _a.texteAide, taille = _a.taille, required = _a.required, image = _a.image, otherProps = __rest(_a, ["label", "name", "value", "disabled", "texteAide", "taille", "required", "image"]);
    var idInput = "".concat(name, "-").concat(value);
    var boutonRadioClassName = "fr-radio-group";
    if (taille && taille !== "md") {
        boutonRadioClassName += " fr-radio-group--".concat(taille);
    }
    if (image) {
        boutonRadioClassName += " fr-radio-rich";
    }
    return (React.createElement("div", { className: boutonRadioClassName },
        React.createElement("input", __assign({ 
            // @ts-ignore
            ref: ref, type: "radio", id: idInput, name: name, value: value, disabled: disabled, required: required }, otherProps)),
        React.createElement("label", { className: "fr-label", htmlFor: idInput },
            label,
            texteAide && React.createElement("span", { className: "fr-hint-text" }, texteAide)),
        image ? React.createElement("div", { className: "fr-radio-rich__img" }, image) : null));
});
BoutonRadio.defaultProps = BoutonRadioDefaultProps;
export default BoutonRadio;
